module.exports = __webpack_public_path__ + "a3d36a6ae62827c2fd2d38d5970f57dc.eot";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-light-webfont.eot
// module id = 133
// module chunks = 0